import nextAction from 'model/actions/utilities/nextAction';

const end = onDone => ({
  title: 'Long Tom',
  description: [
    'this must be one of the villains. the rest must have left this Tom scoundrel behind to die of his consumption',
    'but which boy? is it the one I see in my nightmares? could he be my boy?',
    'I remount my horse and hurry on my way. maybe I can still save someone.'
  ],
  buttons: [nextAction('Continue', onDone)]
});

const boy = onDone => ({
  title: 'Long Tom',
  description: [
    'a wiked smile makes me think the worst',
    '"What boy? My boy?!"',
    '"Whiskey..."',
    'I quickly shovel some more liquid in his mouth. but he says no more',
    '"They left you here to die, didn\'t they. Tell me their names and I WILL find them"',
    'a smile "James... Billy... W..." his head slumps back and he trails off. the wheezing stops.',
    "he's dead",
    'I get back on the horse and push on. must catch up to them.'
  ],
  buttons: [nextAction('Continue', () => onDone(end(onDone)))]
});

const talk = onDone => ({
  title: 'Long Tom',
  description: [
    'I put the bottle on his lips and pour. his eyes focus and a slight smile appears',
    '"You?..."',
    '"Do you know me?" I ask',
    'A feeble grin',
    '"Who are you?"',
    '"...don\'t remember ole\' Tom?... " the words barely said',
    '"Where are the others?" I ask',
    '... took the boy to...'
  ],
  buttons: [nextAction('"What boy?"', () => onDone(boy(onDone)))]
});

const approach = onDone => ({
  title: 'Long Tom',
  description: [
    'a man. half propped against a rock. lanky. head very slowly nodding back and forth.',
    'I approach with a greeting: no response. his eyes are glazed over. his breathing a slow laboured wheezing. broken up only by a cough',
    "a bottle of laudanum clinging to his fingers. he's pale and unnervingly thin",
    'consumptive. not much time left now',
    '"Whiskey" he suddenly whispers'
  ],
  buttons: [nextAction('Give bottle', () => onDone(talk(onDone)))]
});

const start = onDone => ({
  title: 'Long Tom',
  description: [
    "it's been many days of riding alone. no sign of people for miles",
    "suddenly - a plume of smoke on the horizon. coming from the direction I'm headed",
    'a dying fire by the side of the road. down to coals.',
    'I dismount and approach cautiously'
  ],
  buttons: [nextAction('Approach', () => onDone(approach(onDone)))]
});

export default start;
